import { render, staticRenderFns } from "./orderwholesaleform.vue?vue&type=template&id=148109c0"
import script from "./orderwholesaleform.vue?vue&type=script&lang=js"
export * from "./orderwholesaleform.vue?vue&type=script&lang=js"
import style0 from "./orderwholesaleform.vue?vue&type=style&index=0&id=148109c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports